import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { queryKeys } from "#shared/queryKeys/queryKeys";

import { fetchQuoteRequest, QuoteRequestDto } from "./fetchQuoteRequest.api";

export const quoteRequestQuery = (quoteRequestId: string | undefined) => ({
  queryKey: queryKeys.quoteRequests.detail(quoteRequestId),
  queryFn: () => fetchQuoteRequest(quoteRequestId),
  enabled: !!quoteRequestId,
  staleTime: STALE_TIME,
});

export const getQuoteRequestQueryData = (
  queryClient: QueryClient,
  id: string,
): QuoteRequestDto | undefined => {
  return queryClient.getQueryData<QuoteRequestDto>(queryKeys.quoteRequests.detail(id));
};

type QuoteRequestQueryDataUpdater =
  | QuoteRequestDto
  | undefined
  | ((old: QuoteRequestDto | undefined) => QuoteRequestDto | undefined);

export const setQuoteRequestQueryData = (
  queryClient: QueryClient,
  id: string,
  updater: QuoteRequestQueryDataUpdater,
): QuoteRequestDto | undefined => {
  return queryClient.setQueryData<QuoteRequestDto>(queryKeys.quoteRequests.detail(id), updater);
};
